import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useForm, FormProvider } from "react-hook-form";
import { useHistory } from "react-router-dom";
import SearchMembers from "./components/searchMembers";
import ProgramParticipant from "./components/programParticipant";
import { ProgramAttendanceWithoutRegistration } from "../../../../API/API-createattendeeswithoutregistration";
import "../../../../css/programRegistration.css";

function RegistrationForm({
  data,
  userData,
  programData,
  fromHistory,
  registrationSession,
  onCancelRegistrationSession,
  onRegistrationSessionComplete,
}) {
  const useFormMethods = useForm({ mode: "all" });
  const history = useHistory();
  const [memberShipInfo, setMemberShipInfo] = React.useState("");
  const [isDefault, setIsDeafult] = React.useState(false);
  const [addedMembers, setAddedMembers] = React.useState([]);

  const { getValues, setValue } = useFormMethods;

  const handleFoundMembership = (msg) => {
    setMemberShipInfo(msg);
  };

  const handleDefaultMemberShip = (isAdded) => {
    if (isAdded) {
      setIsDeafult(false);
    }
  };

  const handleSubmitAttendance = () => {
    const selectedFamilyMembers = getValues("familyMembers") || [];
    const familyMembers = [...addedMembers, ...selectedFamilyMembers];
    const getAttendanceId = JSON.parse(sessionStorage.getItem("exisitingAttendanceID"));
    const getAttendanceDate = JSON.parse(sessionStorage.getItem("exisitingAttendanceDate"));
    const programID = programData.programID;

    if (!familyMembers.length) return;

    const attendanceObject = {
      date: getAttendanceId ? getAttendanceDate : new Date(),
      programID,
      familyMembers,
    };

    const request = getAttendanceId
      ? ProgramAttendanceWithoutRegistration.PUT.updateProgramAttendeeWithoutRegistartion({
        ...attendanceObject,
        _id: getAttendanceId,
      })
      : ProgramAttendanceWithoutRegistration.POST.createProgramAttendanceByAttendanceID(attendanceObject);

    request
      .then((success) => {
        if (success) {
          sessionStorage.removeItem("exisitingAttendanceID");
          sessionStorage.removeItem("exisitingAttendanceDate");
          sessionStorage.removeItem("familyMembersInfo");
          if (registrationSession) {
            onRegistrationSessionComplete();
            return;
          }
          history.push(`/adminPortal/programs/createAttendance/${programID}`);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (data.membership) {
      setValue("membership", data.membership);
    }
    if (data.familyMembers) {
      setValue("familyMembers", data.familyMembers);
    }
    if (data.caregiverName) {
      setValue("caregiverName", data.caregiverName);
    }
    if (data.caregiverHomePhone) {
      setValue("caregiverHomePhone", data.caregiverHomePhone);
    }
    if (data.caregiverRelationship) {
      setValue("caregiverRelationship", data.caregiverRelationship);
    }
  }, []); 

  return (
    <FormProvider {...useFormMethods}>
      <div
        className={
          registrationSession
            ? "programRegistration-wrapper registrationSession-form"
            : "programRegistration-wrapper"
        }
      >
        {registrationSession && (
          <h2 className="registrationSession-form-title">Registration Session</h2>
        )}
        <SearchMembers
          data={data}
          userData={userData}
          programData={programData}
          isMemberShipAdded={isDefault}
          setIsMemberShipAdded={setIsDeafult}
          sendMembership={handleFoundMembership}
          addedMembers={addedMembers}
          addedFamillyMembers={addedMembers}
          fromHistory={fromHistory}
          registrationSession={registrationSession}
          handleSubmitAttendance={handleSubmitAttendance}
          onCancelRegistrationSession={onCancelRegistrationSession}
          {...useFormMethods}
        />
        <ProgramParticipant
          data={data}
          defaultMemberShip={handleDefaultMemberShip}
          programData={programData}
          memberShipInfo={memberShipInfo}
          userData={userData}
          setAddedMembers={setAddedMembers}
          fromHistory={fromHistory}
          registrationSession={registrationSession}
          handleCompleteRegistrationSession={handleSubmitAttendance}
          {...useFormMethods}
        />
      </div>
    </FormProvider>
  );
}

RegistrationForm.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  programData: PropTypes.shape({
    membership: PropTypes.string,
    weeklyProgram: PropTypes.bool,
  }).isRequired,
  userData: PropTypes.shape({
    userData: PropTypes.shape({
      userType: PropTypes.string,
    }),
  }).isRequired,
  registrationSession: PropTypes.bool,
  onCancelRegistrationSession: PropTypes.func,
  onRegistrationSessionComplete: PropTypes.func,
};

RegistrationForm.defaultProps = {
  registrationSession: false,
  onCancelRegistrationSession: () => {},
  onRegistrationSessionComplete: () => {},
};

export default RegistrationForm;
